import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, staff = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === undefined) {
    return (
      <div className="min-h-screen bg-obsidian grid place-items-center">
        <Loader2 className="w-10 h-10 text-gold animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (staff && !["admin", "processor", "loan_officer"].includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}
